var render, staticRenderFns
import script from "./modules.vue?vue&type=script&lang=js"
export * from "./modules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e9bd1d9')) {
      api.createRecord('0e9bd1d9', component.options)
    } else {
      api.reload('0e9bd1d9', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/treety/modules/modules.vue"
export default component.exports